import get from 'lodash/get';
import trim from 'lodash/trim';
import productConstants from '../../common/ProductConstants';
import { decimalRounding } from '../Pricing/Pricing';

export const setProductAnalytics = (productData, ppId, isSkinCareModal, isHairCare) => {
    // eslint-disable-next-line camelcase
    const { id = '', name = '', price = '0.00', parent_id = '' } = productData;
    const lotID = get(productData, 'custom_data.lot', '');
    const productListPrice = price && decimalRounding(trim(price));
    const productInfo = {
        vendorCartAdd: `revieve:${
            isSkinCareModal
                ? 'skincareadvisor'
                : isHairCare
                ? 'nonpdp-haircareadvisor'
                : 'vto-nonpdp'
        }`,
        // hard coded values as per analytics team
        productCurrentSellingPrice: '0.00',
        productCouponAmount: '0.00',
        productBundleFlag: 'no',
        productQuantity: '1',
        productInStock: 'in stock',
        productDeliveryMethod: productConstants.SHIPTOHOME,
        // these are from revieve api respose
        productPPID: ppId,
        productSKU: id,
        productName: name,
        productListPrice,
        // eslint-disable-next-line camelcase
        productLotId: [lotID],
    };
    return productInfo;
};

export const addRevieveItemsToCart = (productList = [], isSkinCareModal, isHairCare) => {
    const cartItemsToAdd = [];
    const product = [];
    if (productList.length) {
        const cartDetails = {};
        productList.forEach((productData) => {
            const ppId = get(productData, 'custom_data.pdp', '');
            cartDetails.skuId = productData.id;
            cartDetails.quantity = 1;
            cartDetails.ppId = ppId;
            cartDetails.childItems = [];
            cartDetails.deliveryOption = {
                type: productConstants.DELIVERY_HOME,
                selected: true,
                label: productConstants.SHIPTOHOME,
            };
            const cartItemDetails = {
                ...cartDetails,
                ppId: get(productData, 'custom_data.pdp', ''),
            };
            cartItemsToAdd.push(cartItemDetails);
            const productInfo = {
                productInfo: setProductAnalytics(productData, ppId, isSkinCareModal, isHairCare),
            };
            product.push(productInfo);
        });
    }
    return {
        cartItemsToAdd,
        product,
    };
};
